<template>
  <div class="logo" @click="$router.push('/home')">
      <template v-for="(item, index) in 154">
          <img v-show="Index%154==index" :src="require('../../assets/images/logo/'+index+'.png')" :key="index" alt="">
      </template>
  </div>
</template>

<script>
export default {
  components:{},
  props:['Index'],
  data(){
    return {
        
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){
      
  },
  mounted(){}
}
</script>
<style scoped>
.logo {
    width: 2rem;
    height: 2rem;
    margin-left: .4rem;
    margin-top: .1rem;
}
.logo img{
    
    width: 100%;
    height: 100%;
}
</style>